import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: '星球漫画是完全免费的吗？',
    answer: '是的！星球漫画上的所有漫画都可以免费在线阅读，无需注册、无需VIP、无需付费。我们致力于为漫画爱好者提供最优质的免费阅读体验，让每个人都能轻松享受漫画的乐趣。',
  },
  {
    question: '星球漫画支持哪些阅读方式？',
    answer: '星球漫画采用下拉式阅读体验，你只需要在页面中向下滚动即可顺畅地阅读整部漫画。这种阅读方式比传统翻页更加流畅自然，特别适合在手机和电脑上阅读长篇漫画内容。',
  },
  {
    question: '漫画多久更新一次？',
    answer: '我们与多家漫画平台保持合作，大部分热门漫画会保持每日或每周更新。你可以在首页的"最新更新"板块查看最近更新的漫画，也可以在分类页面按更新时间排序，不错过任何精彩内容。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '你可以通过多种方式找到感兴趣的漫画：使用首页的搜索功能、浏览八大分类（热血、搞笑、恋爱、科幻、悬疑、玄幻、都市、校园）、查看推荐榜单，或者直接浏览最新更新列表。我们还会根据热门程度推荐高分漫画。',
  },
  {
    question: '星球漫画有APP吗？在哪里下载？',
    answer: '星球漫画目前主要通过网页版提供服务，你可以直接在浏览器中访问我们的网站进行阅读。网页版完美适配手机、平板和电脑等各类设备，无需下载安装即可享受流畅的漫画阅读体验。我们也在积极开发移动端APP，敬请期待！',
  },
  {
    question: '在星球漫画上阅读漫画流量消耗大吗？',
    answer: '星球漫画采用了智能的图片加载优化技术，会根据你的网络状况自动调整图片清晰度。在WiFi环境下可以享受高清画质，在移动网络下则会优先保证加载速度。总体来说，阅读一部完整漫画的流量消耗在可控范围内。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <section className="py-10 md:py-14 bg-background-100">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
              <i className="ri-question-answer-line text-primary-500 mr-2"></i>
              常见问题
            </h2>
            <p className="text-sm text-foreground-500 mt-1">关于星球漫画的常见疑问解答</p>
          </div>
          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-5 py-4 flex items-center justify-between text-left cursor-pointer hover:bg-background-100/50 transition-colors duration-200"
                >
                  <h4 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {faq.question}
                  </h4>
                  <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-foreground-500"></i>
                  </div>
                </button>
                <div
                  className={`transition-all duration-300 overflow-hidden ${
                    openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </>
  );
}